import { ReactNode } from 'react'

import { StyledList, StyledListItem, ZenkakuSpace } from '../TextStyle'

export const imgItems: { children: ReactNode; id: string }[] = [
  {
    children: (
      <>
        <h3>第1条（利用許諾）</h3>
        <p>
          トライアルグループは、利用者に対し、本規約に規定する利用方法・条件の範囲において、本画像を利用することを非専属的に許諾します。
        </p>
      </>
    ),
    id: 'policy1',
  },
  {
    children: (
      <>
        <h3>第2条（権利の帰属）</h3>
        <StyledList marginLeft="0.5" paddingLeft="0.5">
          <StyledListItem listType="article">
            本画像に関する著作権及び著作人格権はトライアルグループに帰属します。
          </StyledListItem>
          <StyledListItem listType="article">
            本画像は、本規約に規定される条件のもとで利用許諾するものであり、トライアルグループは、利用許諾後も引き続き本画像の利用許諾権を保持します。
          </StyledListItem>
        </StyledList>
      </>
    ),
    id: 'policy2',
  },
  {
    children: (
      <>
        <h3>第3条（利用条件）</h3>
        <StyledList marginLeft="0.5" paddingLeft="0.5">
          <StyledListItem listType="article">
            本画像は、新聞・テレビ・雑誌・オンラインメディア（個人で運営するものも含みます）等において、トライアルグループのトピックスを紹介する記事を作成する際に利用できます。
          </StyledListItem>
          <StyledListItem listType="article">
            本画像はダウンロードされた利用者本人のみが利用できます。
          </StyledListItem>
          <StyledListItem listType="article">
            本画像は、第4条に記載する場合を除き、加工して利用することができます。
          </StyledListItem>
          <StyledListItem listType="article">
            トライアルグループは、本画像に対して利用を許諾しない権利を有します。
          </StyledListItem>
        </StyledList>
      </>
    ),
    id: 'policy3',
  },
  {
    children: (
      <>
        <h3>第4条（禁止事項）</h3>
        <StyledList marginLeft="0.5" paddingLeft="0.5">
          <StyledListItem listType="article">
            営利、非営利を問わず本画像を、そのまま、または加工して、独立の取引対象として、頒布（販売、賃貸、無償配布、無償貸与など）することはできません。また、トライアルグループの運営の妨げになるような利用はできません。
          </StyledListItem>
          <StyledListItem listType="article">
            加工の有無を問わず本画像を含む二次的著作物を主要コンテンツとして、製品に利用すること、その他一切の二次利用はできません。
          </StyledListItem>
          <StyledListItem listType="article">
            加工の有無を問わず本画像を第三者への提供サービス（インターネットのグリーティングカードサービス、テンプレートのダウンロードサービス等への利用や、携帯電話の待受画面としての利用、アプリケーションソフト等の素材サンプルとしての利用、スクリーンセーバーへの利用等を指しますが、これに限りません）に組み込んで頒布することはできません。
          </StyledListItem>
          <StyledListItem listType="article">
            加工の有無を問わず写真を第三者へ提供する目的のプリントサービス等を行うことはできません。
          </StyledListItem>
          <StyledListItem listType="article">
            取引先への提供が目的であっても、利用者が第三者に本画像の利用を許諾することはできません。また、本画像を第三者に譲渡、リースもしくは貸与することはできません。
          </StyledListItem>
          <StyledListItem listType="article">
            本画像を商標、商号その他商品等の表示等に利用し、登記、登録することはできません。
          </StyledListItem>
          <StyledListItem listType="article">
            本画像を他のストックフォトサービスに提供することはできません。
          </StyledListItem>
          <StyledListItem listType="article">
            公序良俗に反する方法での利用、又は公序良俗に反する業務・活動の用に供する目的での利用、反社会的な態様での利用、反社会的な業務・活動に供する目的での利用はできません。
          </StyledListItem>
          <StyledListItem listType="article">
            犯罪等法律に抵触するおそれのある利用その他違法、虚偽あるいは誹謗中傷となるおそれのある利用はできません。また、これらのおそれのある内容を含む記事、映像、宣伝、広告等に関して本画像を利用することはできません。本画像に関する著作権及び著作人格権はトライアルグループに帰属します。
          </StyledListItem>
          <StyledListItem listType="article">
            アダルト（R18）/風俗/性的描写/宗教/麻薬/ストライキ/デモ/反発団体/ドラッグ/ナイトサービス/出会い系サービス（婚活/マッチング/出合い系情報/インターネット異性紹介事業届出業者/その他、出会い系サービスとトライアルグループが判断する場合）等での利用はできません。
          </StyledListItem>
          <StyledListItem listType="article">
            トライアルグループの品位、名誉または信用を害するおそれのある態様、トライアルグループのイメージを損なうおそれのある態様、その他トライアルグループの運営の妨げになるおそれのある態様での利用はできません。
          </StyledListItem>
          <StyledListItem listType="article">
            本画像及び本画像のモデルの品位、名誉または信用を害するおそれのある態様及びイメージを損なうおそれのある態様その他攻撃的、差別的、性的、過激な態様での利用はできません。
          </StyledListItem>
          <StyledListItem listType="article">
            第三者の名誉または信用を害するおそれのある態様及びイメージを損なうおそれのある態様その他第三者に迷惑をかけるおそれのある態様での利用はできません。
          </StyledListItem>
          <StyledListItem listType="article">
            著作・商標権等の知的財産権、財産権、プライバシー権、パブリシティ権、又は肖像権などの権利を侵害する利用、若しくは権利を侵害するおそれのある利用はできません。
          </StyledListItem>
          <StyledListItem listType="article">
            本画像をなりすまし、その他虚偽の情報となりえる態様での利用（個人や団体等の紹介写真、商品や製品等の紹介写真、建物や施設等の紹介写真などを指しますが、これに限りません）はできません。
          </StyledListItem>
          <StyledListItem listType="article">
            本画像のURLを直接呼び出して他のページに表示し、トライアルグループのサーバーに負担をかけるような利用をすることはできません。
            （17）その他、トライアルグループが不適切と判断する利用はできません。
          </StyledListItem>
        </StyledList>
      </>
    ),
    id: 'policy4',
  },
  {
    children: (
      <>
        <h3>第5条（免責）</h3>
        <StyledList marginLeft="0.5" paddingLeft="0.5">
          <StyledListItem listType="article">
            トライアルグループは、本画像に対していかなる保証も行いません。
          </StyledListItem>
          <StyledListItem listType="article">
            トライアルグループは、データの消失、業務の中断、逸失利益、精神的損害等を含め、本画像の利用または利用不能に起因する直接的、間接的、特別、偶発的、結果的、その他いかなる損害にも、一切の責任を負いません。
          </StyledListItem>
        </StyledList>
      </>
    ),
    id: 'policy5',
  },
  {
    children: (
      <>
        <h3>第6条（利用の差し止め等）</h3>
        <p>
          利用者が本規約のいずれかの規定に違反した場合、トライアルグループはただちに利用者による本画像の利用を差止め・本画像の削除を請求することができます。この場合、利用者は、ただちに本画像およびその複製物のすべてを廃棄、抹消または削除しなければなりません。
        </p>
      </>
    ),
    id: 'policy6',
  },
  {
    children: (
      <>
        <h3>第7条（損害賠償）</h3>
        <p>
          利用者が本規約に違反する行為を行ったこと等によりトライアルグループに損害が生じた場合には、利用者はトライアルグループに対して損害を賠償するものとします。
        </p>
      </>
    ),
    id: 'policy7',
  },
  {
    children: (
      <>
        <h3>第8条（規約の改定）</h3>
        <p>
          トライアルグループは、本規約の全部もしくは一部を予告なく変更、追加または廃止することができます。この場合、これらの変更、追加又は廃止による利用者の損害等についてトライアルグループは何ら責任を負うものではありません。
        </p>
      </>
    ),
    id: 'policy8',
  },
  {
    children: (
      <>
        <h3>第9条（準拠法・合意管轄）</h3>
        <StyledList marginLeft="0.5" paddingLeft="0.5">
          <StyledListItem listType="article">
            本規約は日本法に準拠し、日本法に従って解釈されます。
          </StyledListItem>
          <StyledListItem listType="article">
            本規約に関わる紛争が発生した場合は、株式会社トライアルホールディングスの本店所在地を管轄する裁判所を専属的合意管轄裁判所とします。
          </StyledListItem>
        </StyledList>
      </>
    ),
    id: 'policy9',
  },
  {
    children: (
      <>
        <p>
          制定日
          <ZenkakuSpace />
          2022年12月26日
        </p>
      </>
    ),
    id: 'policy10',
  },
]

export const imgLinks: {
  name: string
  anchor: string
}[][] = [
  [
    {
      name: '（利用許諾）',
      anchor: 'policy1',
    },
    {
      name: '（権利の帰属）',
      anchor: 'policy2',
    },
    {
      name: '（利用条件）',
      anchor: 'policy3',
    },
  ],
  [
    {
      name: '（禁止事項）',
      anchor: 'policy4',
    },
    {
      name: '（免責）',
      anchor: 'policy5',
    },
    {
      name: '（利用の差し止め等）',
      anchor: 'policy6',
    },
  ],
  [
    {
      name: '（損害賠償）',
      anchor: 'policy7',
    },
    {
      name: '（規約の改定）',
      anchor: 'policy8',
    },
    {
      name: '（準拠法・合意管轄）',
      anchor: 'policy9',
    },
  ],
]
